import React from 'react';
import TopBar from '../components/TopBar';
import PowerBIEmbed from '../components/PowerBIEmbed';

const CoverageData = ({ userClaims }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <TopBar currentPage="coverage-data" userClaims={userClaims} />
      
      <div className="p-4">
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">Coverage Data Dashboard</h1>
          </div>
          <div className="w-full" style={{ height: 'calc(100vh - 200px)' }}>
            <PowerBIEmbed
              reportId="acb282f5-9e3d-401c-96d3-22ab31be3552"
              workspaceId="7d441575-4aa9-4260-99dd-543f002c0340"
              height={800}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverageData; 